module.exports = __webpack_public_path__ + "fonts/1a1d145.ttf";